import { render, staticRenderFns } from "./press-logos-mobile.vue?vue&type=template&id=462af483&scoped=true&lang=pug&"
var script = {}
import style0 from "./press-logos-mobile.vue?vue&type=style&index=0&id=462af483&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "462af483",
  null
  
)

export default component.exports